import { optionTitle_inlinePreviews } from './InlinePreviewsOption.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
let InlinePreviewsOption: LazyOption = createLazyOption(
    {
        key: 'inlinePreviews',
        titleStringKey: optionTitle_inlinePreviews,
        searchTermsStringKey: optionTitle_inlinePreviews,
    },
    lazyFullModule,
    m => m.default
);
export default InlinePreviewsOption;
